import PresentacionListView from './views/PresentacionCargaLpfListView.vue'
import Presentacion from '../presentacion/views/PresentacionView.vue'

export default [
  {
    path: '/presentaciones-carga-lpf',
    name: 'presentacionesCargaLpf',
    component: PresentacionListView
  },
  {
    path: '/presentacion-carga-lpf/:id',
    name: 'presentacionCargaLpf',
    component: Presentacion
  }
]
